import service from '@/store/services/string-sizer-service';


const state = {
    unique_combinations: [],
};
  
const mutations = {
    SET_COMBINATIONS: (state, combinations) => {
        state.unique_combinations = combinations;
    }
};

const getters = {
    combinations: state => {
        return state.unique_combinations;
    }
};

const actions = {
    getArrangements({ }, params) {
        return service.getArrangements(params)
            .then(({ arrangements }) => {
                return arrangements;
            });
    },
    generatePossibilities({ }, params) {
        return service.generatePossibilities(params)
            .then(({ possibilities }) => {
                return possibilities;
            });
    },
    generatePossibilitiesQueue({ }, params) {
        return service.generatePossibilitiesQueue(params);
    },
    getUniqueCombinations({ commit }, params) {
        return service.getUniqueCombinations(params)
            .then((data) => {
                commit("SET_COMBINATIONS", data.combinations);
            })
    }
}

const string_sizer = {
    namespaced: true,
    actions,
    state,
    getters,
    mutations,
};

export default string_sizer;